(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/components/top-header.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/components/top-header.js');
'use strict';

const _svs$myProfile$react$ = svs.myProfile.react.shared.components,
  BigIcon = _svs$myProfile$react$.BigIcon,
  TopTitle = _svs$myProfile$react$.TopTitle;

const TopHeader = _ref => {
  let title = _ref.title,
    icon = _ref.icon;
  return React.createElement(React.Fragment, null, React.createElement(BigIcon, {
    icon: icon
  }), React.createElement(TopTitle, null, title));
};
svs.myProfile.react.shared.components.TopHeader = TopHeader;

 })(window);